(function () {
    var interviewModule = angular.module('harriApp.interviewV2', []);
})();